/* eslint-disable no-unused-vars */
import React from 'react';
import {
  Button, Dialog, DialogActions, DialogContent, DialogTitle, Slide, makeStyles, useMediaQuery,
} from '@material-ui/core';
import { COUPON_APPLICABLE_CHANNEL_STRING_MAP } from '../../user/const';
import campaignTemplate from './campaignTemplate';

const Transition = React.forwardRef((props, ref) => <Slide direction="up" ref={ref} {...props} />);
const useStyle = makeStyles((theme) => ({
  scrollPaper: {
    alignItems: 'flex-end',

    [theme.breakpoints.up('sm')]: {
      alignItems: 'center',
    },
  },
  paper: {
    height: '90%',
  },
  itemsContainer: {
    marginTop: theme.spacing(2),
    position: 'relative',

    '& > * + *': {
      marginTop: theme.spacing(1),
    },
  },
  content: {
    alignItems: 'stretch',
    display: 'flex',
    flexDirection: 'column',
  },
}));

export default ({
  isOpened,
  onClose,
  data,
}) => {
  const classes = useStyle();
  const isUpSm = useMediaQuery((theme) => theme.breakpoints.up('sm'));
  const fullScreen = !isUpSm;
  const {
    title, description, applicableChannel, template,
  } = data;
  const TemplateCmp = campaignTemplate[template];

  return (
    <Dialog
      classes={{
        scrollPaper: classes.scrollPaper,
        paper: classes.paper,
      }}
      open={isOpened}
      onClose={onClose}
      fullWidth
      maxWidth="xs"
      fullScreen={fullScreen}
      TransitionComponent={Transition}
    >
      <DialogTitle>{title}</DialogTitle>
      <DialogContent className={classes.content}>
        {applicableChannel && (
          <span>{`適用範圍：${COUPON_APPLICABLE_CHANNEL_STRING_MAP[applicableChannel] || ''}`}</span>
        )}
        <span>{description}</span>
        {TemplateCmp
          ? <TemplateCmp data={data} />
          : null}

      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>關閉</Button>
      </DialogActions>
    </Dialog>
  );
};
